import React from 'react';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {allocate} from './data';
import {Container, Map, Image} from '../../../Components/Atom';

import * as S from './style';
import {TitleList} from '../../../Components/Organism';

const Direction = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회안내', '오시는길']} />
			<S.Container>
				<S.ShuttleButtonWrapper>
					<a
						href='https://shuttle-bus-cloudflare.namdotour89.workers.dev'
						target='_blank'
						rel='noopener noreferrer'
					>
						셔틀버스 신청하기
					</a>
				</S.ShuttleButtonWrapper>
				<S.MapWrapper>
					<Map />
				</S.MapWrapper>
				<S.CardSectionWrapper>
					<Image {...allocate.image1} />
					<Image {...allocate.image2} />
				</S.CardSectionWrapper>
				{/* <S.TitleWrapper>
				{allocateDescription.map((description) => (
					<TitleList {...description} />
					))}
				</S.TitleWrapper> */}
			</S.Container>
		</Container>
	);
};

export default Direction;
